export const AT_HOME_ABROAD = 'Tarjeta de Débito At Home Abroad';
export const OPEN_CREDIT = 'Open Credit';
export const CREDIT = 'Credit Card';
export const DEBIT = 'Debit Card';
export const BROKER = 'broker';
export const VALUES_ACCOUNT = 'Cuenta de Valores';
export const FUNDS = 'fondos';
export const ISIN = 'ISIN';
export const DGS = 'DGS';
export const PLANS = 'planes';
export const INVD = 'INVD';
export const PORTFOLIO = 'carteras';
export const DEBIT_ONG_CODE = 'tarjetasolidaria';
export const PRODUCT_SA = 'ER0000014';
